<template>
  <main class="main">
    <div class="group group--narrow support">
      <module-questionnaire
        intake-id="intakeDetail"
        next-route-prefix="support"
        on-complete-route="appointment-type"
        :loading="loadingSingleQuestion"
      />

      <img class="support__image" :src="image" alt="">
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Components
import ModuleQuestionnaire from 'components/Questionnaire';

// Mixins
import MixinIntakeProgress from 'components/IntakeProgress';

import people from 'images/intake/people.png';
import f2f from 'images/intake/f2f-characters.png';

const images = {
  people,
  f2f,
};

// Export
export default {
  name: 'view-support',

  // Components
  components: {
    ModuleQuestionnaire,
  },

  // Mixins
  mixins: [
    MixinIntakeProgress,
  ],

  // Data
  data() {
    return {
      image: images.people,
    };
  },

  // Computed
  computed: {
    ...mapGetters('questions', ['loadingSingleQuestion']),
    ...mapGetters('auth', ['isAuthenticated']),
  },

  // Created
  created() {
    if ( !this.isAuthenticated ) {
      this.checkIntakeRequirements('default', null, null, 'support');

      return;
    }

    this.$router.push({ name: 'home' });
  },

  // LIfecycles
  beforeRouteEnter(to, from, next) {
    if ( !from.name ) {
      next(vm => {
        if ( !vm.checkIntakeRequirements('default', null, null) ) {
          vm.redirectTo('support');
        } else {
          vm.redirectTo('help');
        }
      });
    }

    if(localStorage.getItem('continuedIntake')) {
      to.meta.messages = ['We\'re taking you back to your wellbeing questions'];
      localStorage.removeItem('continuedIntake');
    }
    else {
      to.meta.messages = ['We\'re going to ask you a few questions about your wellbeing. This will take around 2 minutes'];
    }
    next();
  },

};
</script>



// WEBPACK FOOTER //
// SupportDetail.vue?179a1bfa